import type Owner from '@ember/owner';
import { setOwner } from '@ember/owner';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { OtaHotelInfo } from 'lumen/models';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import getAPIErrorMessage from 'lumen/utils/get-api-error-message';
import SilentTaskError from 'lumen/utils/silent-task-error';

export default class OtaHotelInfoResource {
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];
  @service declare store: Services['store'];

  fetchResourceTask = task({ restartable: true }, async () => {
    try {
      const requestParams = {
        subscription_id: this.hotelAndMarketService.hotelOrMarket.id!,
        namespace: APIGATEWAY,
        typeKey: 'usermanagement/otahotelinfos',
      };

      return await this.store.query<OtaHotelInfo>(
        'ota-hotel-info',
        requestParams,
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      throw new SilentTaskError(getAPIErrorMessage(error, this.intl));
    }
  });

  constructor(owner: Owner) {
    setOwner(this, owner);
  }

  fetchResource(): ReturnType<
    OtaHotelInfoResource['fetchResourceTask']['perform']
  > {
    return this.fetchResourceTask.perform();
  }
}
